import { HeroBlock } from "@foodpilot/foods";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { isAppInPDFMode } from "src/utils/rendering";
import { useTokenResolver } from "../../fields/extensions/typingSuggestions/hooks/useTokenResolver";

import { useHeroSection } from "./hooks/useHeroSection";
import { HeroSectionProps } from "./types";

export const HeroSection = (props: HeroSectionProps) => {
    const { title, subtitle, description, imageUrl, ctaLabel, ctaLink } = props;

    const shouldHideButtons =
        isAppInPDFMode() ||
        (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("from") === "templates");

    const { processToken } = useTokenResolver(3);

    const processedTitle = processToken(title);
    const processedSubtitle = processToken(subtitle);
    const processedDescription = processToken(description);
    const processedCtaLabel = processToken(ctaLabel);

    const { callToActionProps, descriptionStyles } = useHeroSection({
        title: processedTitle,
        subtitle: processedSubtitle,
        description: processedDescription,
        imageUrl,
        ctaLabel: processedCtaLabel,
        ctaLink,
    });

    useEffect(() => {
        if (!imageUrl) return;
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = imageUrl;
        link.setAttribute("fetchpriority", "high");
        link.setAttribute("loading", "lazy");
        link.setAttribute("decoding", "async");
        document.head.appendChild(link);
        return () => {
            link.remove();
        };
    }, [imageUrl]);

    return (
        <HeroBlock
            title={processedTitle}
            subtitle={processedSubtitle}
            description={
                processedDescription ?
                    <Box
                        sx={{ ...descriptionStyles, overflowWrap: "anywhere", whiteSpace: "break-spaces" }}
                        dangerouslySetInnerHTML={{ __html: processedDescription }}
                    />
                :   undefined
            }
            callToAction={shouldHideButtons ? undefined : callToActionProps}
            imageUrl={imageUrl}
        />
    );
};
